import { dashboardConstants } from '../constants'

const initialState = {
  list: null,
  error: null,
  loading: false,
  formFilters: null,
  hole: null,
  latitude: 45.48745,
  longitude: 9.20264,
  zoom: 10,
  clusterSize: 50,
  images: null,
  imagesLoading: false,
  showImagesButton: true,
  showImageLayer: false,
  showHoleLayer: true,
  onlyCertifiedImages: false,
}

export default function dashboard(state = initialState, action) {
  switch (action.type) {
    case dashboardConstants.SEARCH:
      return {
        ...state,
        loading: true,
        list: null,
        error: null,
        images: null,
        zoom: 10,
      }
    case dashboardConstants.SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload.list,
        latitude: action.payload.latitude
          ? action.payload.latitude
          : state.latitude,
        longitude: action.payload.longitude
          ? action.payload.longitude
          : state.longitude,
      }
    case dashboardConstants.SEARCH_FAILURE:
      return { ...state, loading: false, error: action.payload }
    case dashboardConstants.GET_SINGLE:
      return { ...state, loading: true }
    case dashboardConstants.GET_SINGLE_SUCCESS:
      return { ...state, loading: false, hole: action.payload }
    case dashboardConstants.GET_SINGLE_FAILURE:
      return { ...state, loading: false, error: action.payload }
    case dashboardConstants.SAVE_FORM_FILTERS:
      return { ...state, formFilters: action.payload }
    case dashboardConstants.CHANGE_MAP_ZOOM:
      return { ...state, zoom: action.payload }
    case dashboardConstants.CHANGE_MAP_CENTER:
      return {
        ...state,
        latitude: action.payload.lat,
        longitude: action.payload.lng,
      }
    case dashboardConstants.CHANGE_CLUSTER_SIZE:
      return { ...state, clusterSize: action.payload }
    case dashboardConstants.RESET_SEARCH:
      return initialState
    case dashboardConstants.EXPORT:
      return { ...state, loading: true }
    case dashboardConstants.EXPORT_SUCCESS:
      return { ...state, loading: false }
    case dashboardConstants.EXPORT_FAILURE:
      return { ...state, loading: false, error: action.payload }
    case dashboardConstants.MASSIVE:
      return { ...state, loading: true, error: null }
    case dashboardConstants.MASSIVE_SUCCESS:
      return { ...state, loading: false, list: null, images: null, error: null }
    case dashboardConstants.MASSIVE_FAILURE:
      return { ...state, loading: false, error: action.payload }
    case dashboardConstants.GET_IMAGES:
      return { ...state, imagesLoading: true, error: null }
    case dashboardConstants.GET_IMAGES_SUCCESS:
      return {
        ...state,
        imagesLoading: false,
        images: action.payload.sort((a, b) =>
          a.mediadate > b.mediadate ? (a.id > b.id ? 1 : 0) : -1
        ),
        // images: ((state.images !== null)
        //   ? state.images.concat(action.payload.filter(x =>
        //     !state.images.some(e => e.guid === x.guid)
        //   ))
        //   : action.payload).sort((a, b) => (a.mediadate > b.mediadate) ? 1 : -1)
      }
    case dashboardConstants.RESET_IMAGES:
      return { ...state, imagesLoading: false, images: null }
    case dashboardConstants.GET_IMAGES_FAILURE:
      return { ...state, imagesLoading: false, error: action.payload }
    case dashboardConstants.SWITCH_IMAGE_LAYER:
      return { ...state, showImageLayer: !state.showImageLayer }
    case dashboardConstants.SWITCH_HOLE_LAYER:
      return { ...state, showHoleLayer: !state.showHoleLayer }
    case dashboardConstants.GENERATING_MISSION:
      return { ...state, loading: true }
    case dashboardConstants.GENERATING_MISSION_SUCCESS:
    case dashboardConstants.GENERATING_MISSION_FAILURE:
    case dashboardConstants.CERTIFY_PHOTO_FAILURE:
    case dashboardConstants.RIPARABLE_PHOTO_FAILURE:
      return { ...state, loading: false }
    case dashboardConstants.CERTIFY_PHOTO:
    case dashboardConstants.RIPARABLE_PHOTO:
      return { ...state, loading: true }
    case dashboardConstants.CERTIFY_PHOTO_SUCCESS:
    case dashboardConstants.RIPARABLE_PHOTO_SUCCESS:
      const hole = state.hole
      if (state.hole) {
        const m = state.hole.medias.map((el) =>
          el.id === action.payload.id ? action.payload : el
        )
        hole.medias = m
      }
      return {
        ...state,
        loading: false,
        images: state.images.map((x) => {
          return x.id === action.payload.id ? action.payload : x
        }),
        hole: state.hole ? hole : state.hole,
      }
    case dashboardConstants.TOGGLE_CERTIFIED_PHOTOS:
      return { ...state, onlyCertifiedImages: !state.onlyCertifiedImages }
    case dashboardConstants.MUST_BE_REPAIRED:
      return { ...state, loading: true }
    case dashboardConstants.MUST_BE_REPAIRED_SUCCESS:
      return { ...state, loading: false, hole: action.payload }
    case dashboardConstants.GMUST_BE_REPAIRED_FAILURE:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

// const geolib = require('geolib')
// return { ...state,
//   imagesLoading: false,
//   images: ((state.images !== null)
//     ? state.images.concat(action.payload.filter(x =>
//       !state.images.some(e => e.guid === x.guid)
//     ))
//     : action.payload).map((x) => {
//     return { ...x, dist: geolib.getDistance({ lat: state.latitude, lng: state.longitude }, { lat: x.latitude, lng: x.longitude }) }
//   }).sort((a, b) => { return a.dist - b.dist })
// }
